// components/ui/tableColumns.ts — a table's column choice, offered inside the Filter card as one more group.
// DataTable provides it around the `filters` node when it has a column picker; FilterMenu appends the group and hands
// the ticks back on Apply. Kept apart from FilterMenu.tsx so that file exports components only (Fast refresh).
import { createContext } from 'react';
import type { FilterGroup } from './FilterMenu';

export interface TableColumnsGroup { group: FilterGroup; value: string[]; apply: (keys: string[]) => void; reset: () => void }
export const TableColumnsContext = createContext<TableColumnsGroup | null>(null);
